import Table from '@risksmart-app/components/src/table';
import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { FC } from 'react';
import { useGetStatelessRegisterTableProps } from 'src/pages/issues/config';
import type { IssueFlatField } from 'src/pages/issues/types';

interface Props {
  loading: boolean;
  records: IssueFlatField[] | undefined;
}

const OversightIssueRegister: FC<Props> = ({ loading, records }) => {
  const tableProps = useGetStatelessRegisterTableProps(
    Parent_Type_Enum.Issue,
    records
  );

  return <Table variant={'embedded'} {...tableProps} loading={loading} />;
};

export default OversightIssueRegister;
